// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1qT6N","text":"SelectPayment_text__34LNj","title":"SelectPayment_title__3tHs7","btn":"SelectPayment_btn___2mI4"};